const DEFAULT_ICONS = {
  hatch: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f95a.svg', // egg
  catch: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f41f.svg', // fish
  adventure: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f3c3.svg', // runner
  friend: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f91d.svg', // handshake
  misc: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/2728.svg' // sparkles
};

const COLOR_PALETTE = [
  '#F87171', // red-400
  '#60A5FA', // blue-400
  '#34D399', // green-400
  '#FBBF24', // amber-400
  '#A78BFA', // violet-400
  '#F472B6', // pink-400
  '#38BDF8', // sky-400
  '#FACC15', // yellow-400
  '#4ADE80', // emerald-400
  '#FB7185'  // rose-400
];

function hashString(input = '') {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

export function getBadgeColor(seed = '') {
  if (!seed) {
    return COLOR_PALETTE[0];
  }
  const hash = hashString(seed);
  return COLOR_PALETTE[hash % COLOR_PALETTE.length];
}

// Emoji-to-Twemoji URL map for badge icons stored as emoji characters
const EMOJI_TO_URL = {
  '\u{1F4A7}': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f4a7.svg', // droplet
  '\u{1FA99}': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1fa99.svg', // coin
  '\u{1F48E}': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f48e.svg', // gem (💎)
  '\u{1F52E}': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f52e.svg', // crystal ball (🔮)
  '\u{1F3C6}': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f3c6.svg', // trophy (🏆)
};

function isUrl(str) {
  return typeof str === 'string' && (str.startsWith('http://') || str.startsWith('https://'));
}

/**
 * Resolve a badge icon to a URL suitable for an <img> tag.
 * Handles: URL strings, emoji characters (mapped to Twemoji SVGs), and category defaults.
 */
export function getBadgeIcon(badge = {}) {
  const icon = badge.iconURL || badge.icon;
  if (icon) {
    if (isUrl(icon)) return icon;
    // Try emoji-to-URL map
    if (EMOJI_TO_URL[icon]) return EMOJI_TO_URL[icon];
    // Generic Twemoji fallback: convert emoji codepoint to URL
    try {
      const codePoint = [...icon][0]?.codePointAt(0)?.toString(16);
      if (codePoint) return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${codePoint}.svg`;
    } catch { /* fall through */ }
  }
  const category = String(badge.category || 'misc').toLowerCase();
  return DEFAULT_ICONS[category] || DEFAULT_ICONS.misc;
}

export function formatThreshold(value) {
  const num = Number(value || 0);
  if (num >= 1000) {
    return `${Math.round(num / 100) / 10}k`;
  }
  return num.toString();
}
